import * as React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { pipe, take } from 'ramda'
import { mapIndexed } from '../util/util'
import dayjs from 'dayjs'
import { Container } from './Container'
import { GraySection } from './GraySection'
import { useQueryParam } from '../hooks/useQueryParam'

export const RelatedBlogPosts: React.FC<{
  posts: any[]
  title: string
  description: string
}> = ({ posts, title, description }) => {
  return (
    <GraySection className="text-center">
      <Container>
        <h3 className={'title'}>{title}</h3>
        <p className="description">{description}</p>
        <div className="grid md:grid-cols-3 gap-4">
          {
            pipe(
              take(3),
              mapIndexed((post: any, index) => (
                <div key={index}>
                  <BlogPostShortView
                    image={post.featured_image}
                    title={post.title}
                    slug={`${post.slug}`}
                    date={post.published}
                  />
                </div>
              ))
            )(posts) as any
          }
        </div>
      </Container>
    </GraySection>
  )
}

const BlogPostShortView: React.FC<{
  image: any
  slug: string
  title: string
  date: Date
}> = ({ title, slug, image, date }) => {
  const query = useQueryParam()
  return (
    <Link href={'/blog/[slug]'} as={{ pathname: `/blog/${slug}/`, query }}>
      <a>
        <div className="flex flex-col bg-white rounded h-full">
          <Image alt={title} layout="responsive" src={image} height={400} width={600} className="w-100 rounded-t" />
          <div className="p-4 text-left flex flex-col flex-grow">
            <p className="text-lg">{title}</p>
            <p className="mt-auto">{dayjs(date).format('MMMM DD, YYYY')}</p>
          </div>
        </div>
      </a>
    </Link>
  )
}
